import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "q-px-none" }
const _hoisted_2 = { class: "flex justify-between items-center q-mb-lg" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "page-subtitle" }, "Postback")
], -1)
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_option_group = _resolveComponent("q-option-group")!
  const _component_PostbackNoteDialog = _resolveComponent("PostbackNoteDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", null, [
          _createVNode(_component_q_btn, {
            onClick: _ctx.addPostback,
            class: "q-btn__main-size text-weight-bold",
            label: "Add",
            color: "primary",
            unelevated: "",
            "icon-right": "add",
            "no-caps": ""
          }, null, 8, ["onClick"])
        ])
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.postbacks, (postback, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "q-mb-lg"
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_q_input, {
              outlined: "",
              label: "Postback",
              dense: "",
              "stack-label": "",
              class: "col-12 q-mr-lg",
              placeholder: _ctx.$t('link'),
              modelValue: postback.url,
              "onUpdate:modelValue": ($event: any) => ((postback.url) = $event),
              error: !!_ctx.errors?.postbacks,
              "error-message": _ctx.errors?.postbacks
            }, {
              append: _withCtx(() => [
                _createVNode(_component_q_btn, {
                  "no-caps": "",
                  onClick: ($event: any) => (_ctx.removePostback(index)),
                  flat: "",
                  rounded: "",
                  size: "9px",
                  disable: _ctx.postbacks.length < 2,
                  icon: _ctx.heroOutline24Trash,
                  dense: ""
                }, null, 8, ["onClick", "disable", "icon"])
              ]),
              _: 2
            }, 1032, ["placeholder", "modelValue", "onUpdate:modelValue", "error", "error-message"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_q_option_group, {
              modelValue: postback.types,
              "onUpdate:modelValue": ($event: any) => ((postback.types) = $event),
              options: _ctx.postbackTypes,
              color: "primary",
              type: "checkbox",
              inline: ""
            }, null, 8, ["modelValue", "onUpdate:modelValue", "options"])
          ])
        ]))
      }), 128))
    ]),
    _createVNode(_component_PostbackNoteDialog, {
      open: _ctx.showPostbackNoteDialog,
      onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showPostbackNoteDialog = false))
    }, null, 8, ["open"])
  ], 64))
}